"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var extrasStyles = styles_1.makeStyles(function () { return ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
    },
}); }, { name: 'GqlCheckout_Extras' });
exports.default = extrasStyles;
